import React from 'react';
import { Box, IconButton, Radio } from '@mui/material';
import { colors, spacing, radius } from 'common/theme';
import { TextHot } from 'components/common/TextHot';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { generateTestId } from 'app/functions';
import { useTranslations } from 'common/hooks/useTranslations';

const MASKED_PREFIX = '**** **** **** ';
const getCardNumber = (cardNumber) => {
  return `${MASKED_PREFIX} ${cardNumber}`;
};
export const PaymentCard = ({
  cardNumber,
  fullName,
  isDefault,
  onDelete,
  onSelectDefault,
  testID,
}) => {
  const { translate } = useTranslations();
  return (
  <Box
    testId={testID}
    dir="rtl"
    sx={{
      width: { xs: '100%', sm: 503 },
      display: 'flex',
      flexDirection: 'column',
      gap: `${spacing.xl}px`,
      padding: `${spacing.xl}px`,
      borderRadius: `${radius.lg}px`,
      border: `1px solid ${colors.palette.blueAlpha200}`,
      backgroundColor: colors.palette.white,
    }}
  >
    <Box
      testId={generateTestId(testID, 'info')}
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
      }}
    >
      <Box testId={generateTestId(testID, 'details')} sx={{ display: 'flex', flexDirection: 'column', gap: `${spacing.sm}px` }}>
        <TextHot testID={generateTestId(testID, 'card-number-text')} size="l" color="primary">
          {getCardNumber(cardNumber)}
        </TextHot>
        <TextHot testID={generateTestId(testID, 'full-name')} size="l" color="subtle" isLtr={true}>
          {fullName}
        </TextHot>
      </Box>
      <IconButton
        testId={generateTestId(testID, 'delete')}
        onClick={onDelete}
        sx={{
          width: spacing.xxl,
          height: spacing.xxl,
          padding: 0,
          color: colors.system.text.subtle,
        }}
      >
        <DeleteOutlineIcon sx={{ fontSize: spacing.xxl }} />
      </IconButton>
    </Box>
    <Box testId={generateTestId(testID, 'default-row')} sx={{ display: 'flex', alignItems: 'center', gap: `${spacing.xs}px` }}>
      <Radio
        testId={generateTestId(testID, 'radio')}
        checked={isDefault}
        onChange={onSelectDefault}
        size="small"
        sx={{
          padding: 0,
          width: spacing.xl,
          height: spacing.xl,
          color: colors.system.border.default,
          '&.Mui-checked': {
            color: colors.system.brand.primary,
          },
          '& .MuiIconHot-root': {
            fontSize: spacing.xl,
          },
        }}
      />
      <TextHot testID={generateTestId(testID, 'default-label')} size="m" color="subtle">
        {translate('default_credit_card_text')}
      </TextHot>
    </Box>
  </Box>
  );
};

export default PaymentCard;

